"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SiteOrderingDetail = void 0;
var _CButton = _interopRequireDefault(require("01_core/components/materials/CButton"));
var _CallAPI = require("01_core/components/system/CallAPI");
var _APIs = require("01_core/constants/APIs");
var _labelConsts = require("01_core/constants/labelConsts");
var _coreConfirmActions = require("01_core/reducers/coreConfirmActions");
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _reactRedux = require("react-redux");
var _OrderingDetail = _interopRequireDefault(require("./components/OrderingDetail"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * 拠点表示順詳細
 */
class SiteOrderingDetail extends _react.default.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "INIT_STATE", {
      detail: [{
        kaishaNm: '',
        siteNm: '',
        siteNo: null,
        areaNm: '',
        buildingNm: ''
      }],
      siteSortOrders: [],
      completed: false
    });
    _defineProperty(this, "returnBtn", () => {
      const {
        completed
      } = this.state;
      const {
        onBack,
        backText
      } = this.props.btnProps;
      return /*#__PURE__*/_react.default.createElement(_CButton.default, {
        negative: true,
        autoWidth: true,
        onClick: onBack(completed)
      }, backText);
    });
    this.state = _objectSpread({}, this.INIT_STATE);
  }

  /**
   * タイトルラベル設定処理
   */
  createTitleLabel() {
    const {
      intl
    } = this.props;
    let titleStr;
    titleStr = intl.formatMessage({
      id: _labelConsts.LABEL.MASTERDATA_SITE_ORDERING_DETAIL_TITLE
    });
    return titleStr;
  }
  componentDidMount() {
    window.scrollTo(0, 0);
    const {
      callAPI,
      detailDispKaishaCd,
      detailDispAreaCd
    } = this.props;

    // 詳細画面表示データの取得
    const sendData = {
      kaishaCd: detailDispKaishaCd,
      areaCd: detailDispAreaCd
    };
    callAPI(_APIs.SITE_ORDERING_REFER, sendData).then(response => {
      if (response.status === _APIs.STATUS.SUCCESS) {
        let detail = response.data.results;
        this.setState({
          detail
        });
      }
    });
  }
  render() {
    const {
      action
    } = this.props;
    const {
      completed,
      detail
    } = this.state;
    return /*#__PURE__*/_react.default.createElement(_OrderingDetail.default, {
      action: action,
      title: this.createTitleLabel(),
      returnBtn: this.returnBtn(),
      detail: detail,
      completed: completed
    });
  }
}
exports.SiteOrderingDetail = SiteOrderingDetail;
const mapStateToProps = state => {
  return {
    dispContent: state.siteOrdering.dispContent,
    detailDispKaishaCd: state.siteOrdering.detailDispKaishaCd,
    detailDispAreaCd: state.siteOrdering.detailDispAreaCd
  };
};
const mapDispatchToProps = dispatch => {
  return {
    openConfirm: (title, message, onClickOk) => dispatch(_coreConfirmActions.coreConfirmActions[_coreConfirmActions.TYPES_CONFIRM.OPEN](title, message, onClickOk))
  };
};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactIntl.injectIntl)((0, _CallAPI.withCallAPI)(SiteOrderingDetail)));